import React from 'react'

import './Header.css'

const Header = (props) => {
    
    return (
        <div className="Header">
            <div className="HeaderGroup">
                <span style={{flex:1}}></span>
                <div><a href="/policy">Privacy Policy</a></div>
            </div>
        </div>
    )
}

export default Header;


// WEBPACK FOOTER //
// ./src/Components/Header/index.js